// extracted by mini-css-extract-plugin
module.exports = {"quick-replies-wrapper":"Nl1llp","show":"_1UcrxP","quick-replies":"_3GBsJ5","quick-reply-wrapper":"_3Ba8xc","quick-reply":"_1_cx7n","first-item":"_3AUXXg","last-item":"_2NeLmJ"};